module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAIdJREFUOE+10jEOwjAMheH/qcehO+rGwsjQAzIyMlSdEbfgEFzCXVyJIY1TrGZN8sl+tkgeJf9zDGBmF+Ar6RNVWKzAgTtwi5DNFhyZgXMNqWbgyBs4bSFhiCsiqfi2FXhJ6kqBtrQwAcPuFrz0B3DdHaKZ9cATGP8aY3qRou37vQ+nEGFpYAEz9jARWnP30gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/arrow.png
// module id = 2EaG
// module chunks = 0